import { ProductTypeId, TerminalType } from "../types/types";

type Option<T extends string> = { id: T; label: string };

export const PRODUCT_TYPE_OPTIONS: ReadonlyArray<Option<ProductTypeId>> = [
  { id: ProductTypeId.PDC, label: "Pompa di calore" },
  { id: ProductTypeId.IBRIDO_FACTORY, label: "Sistema ibrido Factory Made" },
  { id: ProductTypeId.IBRIDO_BIVALENTE_LT35, label: "Sistema ibrido bivalente o pompa di calore add-on (caldaia < 35 kW)" },
  { id: ProductTypeId.IBRIDO_BIVALENTE_GT35, label: "Sistema ibrido bivalente o pompa di calore add-on (caldaia > 35 kW)" },
  { id: ProductTypeId.SCALDACQUA, label: "Scaldacqua in pompa di calore" },
];

export const TERMINAL_OPTIONS: ReadonlyArray<Option<TerminalType>> = [
  {
    id: TerminalType.BASSA,
    label: "Bassa temperatura: pannelli radianti, ventilconvettori (BT), UTA (BT), TABS",
  },
  {
    id: TerminalType.MEDIA,
    label: "Media temperatura: radiatori, aerotermi (industriali), ventilconvettori (MT), termostrisce, UTA (MT), altro",
  },
];

export const TERMINAL_LABEL_BY_ID: Record<TerminalType, string> = {
  [TerminalType.BASSA]: "Bassa temperatura: pannelli radianti, ventilconvettori (BT), UTA (BT), TABS",
  [TerminalType.MEDIA]: "Media temperatura: radiatori, aerotermi (industriali), ventilconvettori (MT), termostrisce, UTA (MT), altro",
};

export const HEAT_PUMP_PRODUCT_TYPES: ReadonlyArray<ProductTypeId> = [
  ProductTypeId.PDC,
  ProductTypeId.IBRIDO_FACTORY,
  ProductTypeId.IBRIDO_BIVALENTE_LT35,
  ProductTypeId.IBRIDO_BIVALENTE_GT35,
];
